export class FeedbackDTO {
  type: string;
  feedback: string;
  firstName: string;
  lastName: string;
  email: string;
}
